import type { Discount } from "@/types/external"

/** One summary row per coupon code: its allocations added up, in the order the server returned them. */
export function appliedCouponLines(couponDiscounts: readonly Discount[]): { code: string; value: number }[] {
  const totals = new Map<string, number>()
  for (const discount of couponDiscounts) {
    for (const sponsorship of discount.sponsorshipValues) {
      totals.set(sponsorship.discountCode, (totals.get(sponsorship.discountCode) ?? 0) + sponsorship.amount.value)
    }
  }
  return [...totals].map(([code, value]) => ({ code, value: Math.round(value * 100) / 100 }))
}
